import { html } from 'lit';
import { ArrowRight } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-arrow-right')
export class PdsIconArrowRight extends PdsIcon {
  @state()
  icon = ArrowRight;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
